import wifi from '../images/amenties/wifi.png';
import airport from '../images/amenties/airport.png';
import coffeeMaker from '../images/amenties/coffee-maker.png';
import gym from '../images/amenties/gym.png';
import parking from '../images/amenties/parking.png';
import pool from '../images/amenties/pool.png';
import restaurant from '../images/amenties/restaurant.png';
import spa from '../images/amenties/spa.png';
import bedroom from '../images/amenties/bedroom.png';
import roomService from '../images/amenties/room-service.png';

export const amenties = [

    {
        id: 1,
        title: "wifi",
        image: wifi
    },
    {
        id: 2,
        title: "Swimming Pool",
        image: pool
    },
    {
        id: 3,
        title: "gym",
        image: gym
    },
    {
        id: 4,
        title: "room service",
        image: roomService
    },
    {
        id: 5,
        title: "free parking",
        image: parking
    },
    {
        id: 6,
        title: "Kitchen in Double/Single bedrooms",
        image: bedroom
    },

    //added
    {
        id: 7,
        title: "spa",
        image: spa
    },
    {
        id: 8,
        title: "Restaurant",
        image: restaurant
    },
    {
        id: 9,
        title: "Airport Shuttle",
        image: airport
    },
    {
        id: 10,
        title: "Tea/Coffee maker",
        image: coffeeMaker
    },
    

]